module.exports = __webpack_public_path__ + "./favicons/android-icon-192x192.png";